import { getPlayersByPlayerExternalIdOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

export const usePlayerInfo = (params: { playerId: string }) => {
  const { playerId } = params;

  const { isLoading, data, error } = useQuery({
    ...getPlayersByPlayerExternalIdOptions({
      path: { player_external_id: encodeURIComponent(playerId.toString()) },
      query: {},
    }),
    enabled: !!playerId,
    retry: false,
  });

  return {
    isLoading,
    data,
    error,
  };
};
